import { render, staticRenderFns } from "./TopicListComponent.vue?vue&type=template&id=89a737dc&"
import script from "./TopicListComponent.vue?vue&type=script&lang=js&"
export * from "./TopicListComponent.vue?vue&type=script&lang=js&"
import style0 from "./TopicListComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports